export const LIBELLE_MES_CONTROLES = "Mes contrôles en cours";
export const LIBELLE_TOUS_LES_CONTROLES_EN_COURS =
  "Tous les contrôles en cours";
export const LIBELLE_TOUS_LES_CONTROLES = "Tous les contrôles";

export const FIL_ARIANE_MES_CONTROLES = {
  label: LIBELLE_MES_CONTROLES,
  value: "/",
};
